"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentFrequencies = void 0;
var PaymentFrequencies;
(function (PaymentFrequencies) {
    PaymentFrequencies["MANUAL"] = "manual";
    PaymentFrequencies["MONTHLY"] = "monthly";
    PaymentFrequencies["QUARTERLY"] = "quarterly";
    PaymentFrequencies["SEMIANNUAL"] = "semiannually";
    PaymentFrequencies["ANNUAL"] = "annually";
})(PaymentFrequencies = exports.PaymentFrequencies || (exports.PaymentFrequencies = {}));
